import React, { useEffect, useState } from "react";
import { Markup } from "interweave";
import flag from "../../../../../assets/images/flag.png";
import flag1 from "../../../../../assets/images/Registration-End-01.1.png";
import flag2 from "../../../../../assets/images/Maximum-Time-01.1.png";
import flag3 from "../../../../../assets/images/Minimum-Time-01.1.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import ReactPlayer from "react-player";

import { Nav, Tab } from "react-bootstrap";
import ReUseableSingleRoundTab from "../../../../Reuseable/ReUseableSingleRoundTab";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const ScheduleTableCard = ({ date, time }) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const params = useParams();
  const [postDetails, setPostDetails] = useState([]);
  const [totalVideos, setTotalVideos] = useState();

  const [rounds, setRounds] = useState([]);
  const [auditionRoundInfos, setAuditionRoundInfos] = useState([]);
  const [roundParticipant, setRoundParticipant] = useState();
  const [roundCertification, setRoundCertification] = useState();
  const [roundAppeal, setRoundAppeal] = useState();
  const [roundWinner, setRoundWinner] = useState();
  const [roundFailed, setRoundFailed] = useState();

  const [activeRound, setActiveRound] = React.useState(0);

  

  const activeRoundHadler = (id) => {
    setActiveRound(id);
    fetchRoundInfos(id);
  };

  useEffect(() => {
    axios
      .get(
        `/api/audition-admin/dashboard/post-details/${params.id}/${params.type}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setPostDetails(res.data.post);
          setTotalVideos(res.data.participant);
          setRounds(res.data.post?.info?.audition_rounds);
          setActiveRound(res.data.post.active_round_info_id);
        }
      });
  }, []);

  const fetchRoundInfos = (id) => {
    axios
      .get(`/api/audition-admin/dashboard/audition/roundInfo/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          
          setAuditionRoundInfos(res.data?.auditionRoundInfos);
          setRoundParticipant(res.data?.roundParticipant);
          setRoundAppeal(res.data?.roundAppeal);
          setRoundWinner(res.data?.roundWinner);
          setRoundFailed(res.data?.roundFailed);
          setRoundCertification(res.data?.roundCertification);
        }
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <div className="card card-bg p-2">
            {postDetails?.banner ? (
              <img
                src={imageCdnUrl+postDetails?.banner}
                className="img-fluid card-img-details"
                alt=""
              />
            ) : (
              <ReactPlayer
                url={videoCdnUrl+postDetails?.video}
                controls={true}
                volume={1}
                width="100%"
                height="200px"
                style={{ margin: "0 auto" }}
              />
            )}
          </div>
        </div>

        <div className="col-md-6 mb-3">
          <div className="card bg-dark">
            <div className="row">
              <div className="registration-head  card-bg mb-1">
                <h5 className="text-warning fw-bold p-2">Registration: </h5>
              </div>

              <div className="row registration-body  card-bg m-0 pt-3">
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2 text-light">
                      <span>
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                      <span>
                        {moment(postDetails?.user_reg_start_date).format("LL")}
                      </span>{" "}
                      -{" "}
                      <span>
                        {moment(postDetails?.user_reg_end_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag1} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Participate :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {postDetails?.participant?.length}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag1} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Total Round :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {postDetails?.audition_round?.length}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag1} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">
                        Total Uploaded Videos :
                      </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {totalVideos}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag2} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">
                        Date : {moment(postDetails?.created_at).format("LL")}
                      </span>
                      <br></br>
                      <span className=" text-warning fw-bold">{date}</span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag3} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">
                        Time :{" "}
                        {moment(postDetails?.created_at).format("HH:mm a")}
                      </span>
                      <br></br>
                      <span className=" text-warning fw-bold">{time}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h5 className="text-light pb-3">{postDetails?.title}</h5>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={postDetails?.description} />
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Component */}
      <div>
        <Tab.Container id="left-tabs-example" defaultActiveKey={activeRound}>
          <div className="container-lg my-3">
            <Nav variant="pills">
              <div className="row">
                {rounds &&
                  rounds.map((auditionRound, index) => (
                    <ReUseableSingleRoundTab
                      key={index}
                      auditionRound={auditionRound}
                      setActiveRound={activeRoundHadler}
                    />
                  ))}
              </div>
            </Nav>
            <div className="my-4"></div>
          </div>

          <div>
            <Tab.Content>
              <Tab.Pane eventKey={activeRound}>
                <div className="row mb-4">
                  <div className="col-md-3 mb-2">
                    <div className="card bg-black p-2">
                      <b className="b-text">
                        Total Videos : &nbsp;
                        <span className="small-text">
                          {auditionRoundInfos?.videos?.length}
                        </span>
                      </b>
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="card bg-black p-2">
                      <b className="b-text">
                        Total Participant : &nbsp;
                        <span className="small-text">{roundParticipant}</span>
                      </b>
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="card bg-black p-2">
                      <b className="b-text">
                        Total Appeal : &nbsp;
                        <span className="small-text">{roundAppeal}</span>
                      </b>
                    </div>
                  </div>

                  <div className="col-md-3 mb-2">
                    <div className="card bg-black p-2">
                      <b className="b-text">
                        Total Certificate download : &nbsp;
                        <span className="small-text">{roundCertification}</span>
                      </b>
                    </div>
                  </div>

                  <div className="col-md-3 mb-2">
                    <div className="card bg-black p-2">
                      <b className="b-text">
                        Total Round Winner : &nbsp;
                        <span className="small-text">{roundWinner}</span>
                      </b>
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="card bg-black p-2">
                      <b className="b-text">
                        Total Round Failed : &nbsp;
                        <span className="small-text">{roundFailed}</span>
                      </b>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>

      {/* Tab Component End*/}

      <div className="row my-3">
        <div className="col-md-12 col-lg-6 mb-3">
          <h5 className="head-line text-warning card-bg p-2">
            Participate List
          </h5>

          <div className="tr-odd-wallet">
            <table className="table w-100">
              <thead className="bg-warning">
                <tr>
                  <th scope="col" className="text-black fw-bold">
                    #
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Name
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Email
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Register Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {postDetails?.participant?.map((data, index) => (
                  <tr className="tr-child-wallet">
                    <th scope="row">{index + 1}</th>
                    <td>
                      {data?.participant?.first_name +
                        " " +
                        data?.participant?.last_name}
                    </td>
                    <td>{data?.participant?.email}</td>
                    <td> {moment(data?.created_at).format("LL")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 mb-3">
          <h5 className="head-line text-warning card-bg p-2">Assign Judge</h5>

          <div className="tr-odd-wallet">
            <table className="table w-100">
              <thead className="bg-warning">
                <tr>
                  <th scope="col" className="text-black fw-bold">
                    #
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Judges
                  </th>
                </tr>
              </thead>
              <tbody>
                {postDetails?.assigned_judges?.map((judge, index) => (
                  <tr className="tr-child-wallet">
                    <th scope="row">{index + 1}</th>
                    <td>
                      {judge?.user?.first_name + " " + judge?.user?.last_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="col-md-6  col-lg-3 mb-3">
          <h5 className="head-line text-warning card-bg p-2">Assign Juries</h5>

          <div className="tr-odd-wallet">
            <table className="table w-100">
              <thead className="bg-warning">
                <tr>
                  <th scope="col" className="text-black fw-bold">
                    #
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Jury
                  </th>
                </tr>
              </thead>
              <tbody>
                {postDetails?.assigned_juries?.map((judge, index) => (
                  <tr className="tr-child-wallet">
                    <th scope="row">{index + 1}</th>
                    <td>
                      {judge?.user?.first_name + " " + judge?.user?.last_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleTableCard;
